import {
  TableCellType,
  TableHeader,
} from "../../../../../../components/custom-table/table";
import { FormMatrixTableColumnKeys } from "../../../../../../enums/tableColumnKeys";

export const FormMatrixTableHeader: TableHeader[] = [
  {
    label: "Form Name",
    key: FormMatrixTableColumnKeys.FORM_NAME,
    order: 1,
    width: 40,
    sortable: true,
    type: TableCellType.STRING,
  },
  {
    label: "ICD",
    key: FormMatrixTableColumnKeys.ICD,
    order: 2,
    width: 10,
    sortable: false,
    type: TableCellType.TOGGLE_SWITCH,
  },
  {
    label: "Dosage",
    key: FormMatrixTableColumnKeys.DOSAGE,
    order: 3,
    width: 10,
    sortable: false,
    type: TableCellType.TOGGLE_SWITCH,
  },
  {
    label: "Dosage Instr.",
    key: FormMatrixTableColumnKeys.DOSAGE_INSTR,
    order: 4,
    width: 10,
    sortable: false,
    type: TableCellType.TOGGLE_SWITCH,
  },
  {
    label: "EV",
    key: FormMatrixTableColumnKeys.EV,
    order: 5,
    width: 10,
    sortable: false,
    type: TableCellType.TOGGLE_SWITCH,
  },
  {
    label: "DAW",
    key: FormMatrixTableColumnKeys.DAW,
    order: 6,
    width: 10,
    sortable: false,
    type: TableCellType.TOGGLE_SWITCH,
  },
  {
    label: "Review Needed",
    key: FormMatrixTableColumnKeys.REVIEW_NEEDED,
    order: 7,
    width: 10,
    sortable: false,
    type: TableCellType.TOGGLE_SWITCH,
  },
  {
    label: "",
    key: FormMatrixTableColumnKeys.DELETE,
    order: 8,
    width: 5,
    sortable: false,
    type: TableCellType.DELETE_ICON,
  },
];
